import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const DOT_SVGS = ['https://cdn.magicpatterns.com/uploads/p5pHA6WjKLC2abHxZ6MC96/sj-website-dot-1.svg', 'https://cdn.magicpatterns.com/uploads/a6RHQv8s4Ej3zKfsF7PwQM/sj-website-dot-2.svg', 'https://cdn.magicpatterns.com/uploads/gaX1T3ij2V9Vt3GfbTpwAS/sj-website-dot-3.svg'];
const STEP_ICONS = ['https://cdn.magicpatterns.com/uploads/pUoa9AgiNV3JkNxm1FaxqP/sj-website-icon-book-cleaning.svg', 'https://cdn.magicpatterns.com/uploads/qFMAXY9Wp1x99zCeLMk733/sj-website-icon-confirm-booking.svg', 'https://cdn.magicpatterns.com/uploads/4bn9D37fikaWvnLSCx2WDq/sj-website-icon-we-clean-it.svg'];
export function BookOnlineSection() {
  const steps = [{
    title: 'Book a cleaning',
    description: 'Choose your service, date, and time that works best for you.'
  }, {
    title: 'Confirm booking',
    description: 'Review your details and confirm your secure booking.'
  }, {
    title: "We'll clean it",
    description: 'Our professional team arrives and delivers a spotless clean.'
  }];
  return <section className="bg-white py-24 md:py-32 relative z-20" data-id="element-36">
      <div className="container mx-auto px-6 md:px-12" data-id="element-37">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-38">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="max-w-xl" data-id="element-39">
            <div className="flex items-baseline gap-6 mb-16" data-id="element-40">
              <h2 className="text-5xl md:text-7xl font-heading font-bold text-primary uppercase leading-none tracking-tight" data-id="element-41">
                Book <br data-id="element-42" /> Online
              </h2>
              <span className="font-script text-3xl md:text-4xl text-primary/80 -rotate-6" data-id="element-43">
                Fast & Secure
              </span>
            </div>

            <div className="space-y-12" data-id="element-44">
              {steps.map((step, index) => <div key={index} className="flex gap-6 relative group" data-id="element-45">
                  {/* Connecting Line */}
                  {index !== steps.length - 1 && <div className="absolute left-6 top-16 bottom-[-3rem] w-px bg-gray-200 group-hover:bg-accent transition-colors duration-300" data-id="element-46"></div>}

                  {/* Step Icon */}
                  <div className="relative z-10 w-12 h-12 shrink-0 flex items-center justify-center" data-id="element-47">
                    {STEP_ICONS[index] ? <img src={STEP_ICONS[index]!} alt="" className="w-12 h-12" data-id="element-48" /> : <div className="w-12 h-12 rounded-full border-2 border-primary flex items-center justify-center bg-white" data-id="element-49">
                        <span className="text-primary font-bold text-lg" data-id="element-50">
                          {index + 1}
                        </span>
                      </div>}
                  </div>

                  {/* Content */}
                  <div data-id="element-51">
                    <div className="flex items-center gap-3 mb-2" data-id="element-52">
                      <img src={DOT_SVGS[index]} alt="" className="h-4" data-id="element-53" />
                      <h3 className="text-xl font-bold text-primary uppercase tracking-wide group-hover:text-accent transition-colors duration-300" data-id="element-54">
                        {step.title}
                      </h3>
                    </div>
                    <p className="text-gray-600 leading-relaxed" data-id="element-55">
                      {step.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative h-[600px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-56">
            <img src="https://cdn.magicpatterns.com/uploads/5fK9W2h9HCXcPgfRkHN8sp/3d-rendering-loft-scandinavian-living-room-with-working-table-bookshelf.jpg" alt="Clean modern living room showcasing professional cleaning results by Smith & Jengs" loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-57" />
          </motion.div>
        </div>
      </div>
    </section>;
}